
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ButtonLight.css"

function ButtonLight({ text, icon, onClick }) {


    return (
        <>
            <button className="button_light" onClick={() => onClick()}>
                <FontAwesomeIcon icon={icon} className="mr-5 opacity-50" /> {text}
            </button>
        </>
    )
}

export default ButtonLight;